import { IIconProps } from './add';

export const IcoWarning: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    cy={`IcoWarning${cy}`}
  >
    <path
      d="M8.625 12.125H10.375V13.875H8.625V12.125ZM8.625 5.125H10.375V10.375H8.625V5.125ZM9.49125 0.75C4.66125 0.75 0.75 4.67 0.75 9.5C0.75 14.33 4.66125 18.25 9.49125 18.25C14.33 18.25 18.25 14.33 18.25 9.5C18.25 4.67 14.33 0.75 9.49125 0.75ZM9.5 16.5C5.6325 16.5 2.5 13.3675 2.5 9.5C2.5 5.6325 5.6325 2.5 9.5 2.5C13.3675 2.5 16.5 5.6325 16.5 9.5C16.5 13.3675 13.3675 16.5 9.5 16.5Z"
      fill="#FF1F1F"
    />
  </svg>
);
